<div class=" devices_sum_wrapper ">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border">Device Information</legend>
        <div class="col-md-12">
            <form name="device_form" #device_form="ngForm" (ngSubmit)="saveDevice()">
                <div *ngIf="viewModel" class="row">




                    <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col  ">
                        <div class="form-group has-feedback">
                            <label for="deviceName">Device Name:</label>
                            <input type="text" id="deviceName" name="deviceName" placeholder="Name" [(ngModel)]="viewModel.Device.Name" #deviceName="ngModel" class="form-control" autofocus minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': deviceName.invalid && (deviceName.dirty || deviceName.Select)}"
                                required />

                            <div *ngIf="deviceName.invalid && (deviceName.dirty || deviceName.Select)" class="invalid-feedback">
                                <div *ngIf="deviceName.errors?.required">Device Name is required</div>
                                <div *ngIf="deviceName.errors?.minlength || deviceName.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col  ">
                        <div class="form-group has-feedback">
                            <label for="deviceCode">Device Code:</label>
                            <input type="text" id="deviceCode" name="deviceCode" placeholder="Code" #deviceCode="ngModel" [(ngModel)]="viewModel.Device.DeviceCode" class="form-control" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': deviceCode.invalid && (deviceCode.dirty || deviceCode.Select)}"
                                required />

                            <div *ngIf="deviceCode.invalid && (deviceCode.dirty || deviceCode.Select)" class="invalid-feedback">
                                <div *ngIf="deviceCode.errors?.required">Device Code is required</div>
                                <div *ngIf="deviceCode.errors?.minlength || deviceCode.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col  ">
                        <div class="form-group has-feedback">
                            <label for="modelNo">Model No.</label>
                            <input type="text" id="modelNo" name="modelNo" placeholder="Model No." #modelNo="ngModel" [(ngModel)]="viewModel.Device.ModelNo" class="form-control" minlength="2" maxlength="25" [ngClass]="{ 'is-invalid': modelNo.invalid && (modelNo.dirty || modelNo.Select)}"
                                required />

                            <div *ngIf="modelNo.invalid && (modelNo.dirty || modelNo.Select)" class="invalid-feedback">
                                <div *ngIf="modelNo.errors?.required">Model No. is required</div>
                                <div *ngIf="modelNo.errors?.minlength || modelNo.errors?.maxlength">Min 2 to 25 characters are allowed</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col  ">
                        <div class="form-group has-feedback">
                            <label for="assignDate" class="control-label">Assign Date:</label>
                            <input class="form-control" id="assignDate" name="asignDate" placeholder="Assign Date" [(ngModel)]="assignDate" ngbDatepicker #asignDate="ngbDatepicker" (click)="asignDate.toggle()" [ngClass]="{ 'is-invalid': asignDate.invalid && (asignDate.dirty || asignDate.Select)}"
                                style="cursor: pointer;" readonly required>

                            <div *ngIf="asignDate.invalid && (asignDate.dirty || asignDate.Select)" class="invalid-feedback">
                                <div *ngIf="asignDate.errors?.required">Assign Date is required</div>

                            </div>
                            <!-- <button class="btn btn-outline-secondary calendar " (click)="asignDate.toggle()"
                                    type="button"></button>   -->
                            <i (click)="asignDate.toggle()" class="fa fa-calendar " aria-hidden="true" style="position: absolute;right: 20px;top:35px;z-index:9;"></i>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col  ">
                        <div class="form-group has-feedback">
                            <label for="deviceType">Type:</label>
                            <select [(ngModel)]="viewModel.Device.Type" name="devices" required style="cursor: pointer;" class="form-control">
                                <!-- <option [ngValue]="null" >Android</option> -->
                                <option value="" [ngValue]="null" style="display: none">Select</option>
                                <option value="1">Android</option>
                                <option value="2">IOS</option>
                                <option value="3">Truck</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2 col-lg-2 employee_sum_col  ">
                        <div class="form-group has-feedback">
                            <label class="control-label">Assigned to Driver:</label>
                            <select [(ngModel)]="viewModel.Device.DriverId" name="drivers" required style="cursor: pointer;" class="form-control">
                                <option [ngValue]="null" value="" style="display: none">--- Please Select ---</option>
                                <option *ngFor="let driver of viewModel.Drivers" [value]="driver.Id">{{driver.Name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12   ">

                        <div class="form-group orders_sum_top device_sum_top buttons_rght ">
                            <div class="pull-right">
                                <button type="submit" class="btn btn-primary" [disabled]="!device_form.valid">Save</button>
                                <button type="button" id="resetDeviceform" class="btn btn-default" (click)="device_form.reset()">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>

    <fieldset class="scheduler-border marign_10">
        <legend class="scheduler-border">Device Information</legend>
        <div class="panel_table">
            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>
                                <th>Device Name</th>
                                <th>Device Code </th>
                                <th>Model No.</th>
                                <th>Type </th>
                                <th>Assigned to Driver</th>
                                <th>Assigned Date</th>
                                <th>Device Created Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="devices">
                            <tr *ngFor="let mod of devices.Devices">
                                <td>{{mod.Name}}</td>
                                <td>{{mod.DeviceCode}}</td>
                                <td>{{mod.ModelNo}}</td>
                                <td *ngIf="mod.Type==1">Android</td>
                                <td *ngIf="mod.Type==2">IOS</td>
                                <td *ngIf="mod.Type==3">Truck</td>
                                <td>{{mod.DriverName}}</td>
                                <td>{{mod.AssignDate | date:'MM/dd/yyyy'}}</td>
                                <td>{{mod.InsertDate | date:'MM/dd/yyyy'}}</td>
                                <td>
                                    <a class="btn btn-small btn-link" (click)="edit(mod)"> <i class="fa fa-pencil fa-lg" aria-hidden="true"></i> </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="devices?.PaginatedResult?.TotalRecords > 10" style="float: right;">
                        <ngb-pagination [(page)]="pageNo" [maxSize]="10" [collectionSize]="devices?.PaginatedResult?.TotalRecords" [ellipses]="true" [boundaryLinks]="true" (pageChange)="GetDevices($event)">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <br>

</div>